export enum BillingLevelType {
  Contract = "CONTRACT",
  Clin = "CLIN",
  Project = "PROJECT",
  Task = "TASK"
}
